import React, { useState, useEffect } from 'react';
import DataTable from 'react-data-table-component';
import ExpandedRowComponent from '../pages/grid-orderdetails';
import { OverlayTrigger, Popover, Button, Modal, Col, Form, Row, Tooltip } from 'react-bootstrap';
import { ListGroup } from 'react-bootstrap'
import ResetDashboardLoan from '../pages/Modal/reset-loan';
import LoanImportData from '../pages/New-window/loan-import-data'
import ReactDOM from 'react-dom/client';
import CreateLoan from '../pages/Modal/create-loan';
import { useNavigate } from 'react-router-dom';
import { BiChevronRightCircle } from "react-icons/bi";
import { configData } from "../config/systemconfigurationconstants";
import UseLambdaInvocations from '../hooks/useLambdaInvocations';
import lambdaConfig from '../hooks/lambdaConfig';
import { ToastContainer, toast } from "react-toastify";
import * as AWS from 'aws-sdk';
import { useEncryption } from '../customHooks/useEncryption';
const DashboardGridData = ({ headers, data, usecaseListForFileCreations, clientListForFileCreations, admindetailsFromMainForFileCreation, resetPaginationToggle, createLoanUsecaseid, createLoanClientid }) => {
    const { encrypt, decrypt } = useEncryption();
    const getCookie = (name) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return decodeURIComponent(parts.pop().split(';').shift());
        }
        return null;
    };
    const [userRights] = useState(JSON.parse(localStorage.getItem("UserRights")));
    const [rolesAndRights] = useState(JSON.parse(localStorage.getItem("RolesAndRights")));
    const lambda = new AWS.Lambda({
        region: configData.LAMBDA_REGION,
        accessKeyId: decrypt(getCookie('ak')),
        secretAccessKey: decrypt(getCookie('sk'))
    });
    const { invokeLambda, loading, error } = UseLambdaInvocations();
    const [dotloader, setDotLoader] = useState(true);

    // Add Fiels to new loan
    const navigate = useNavigate();
    const [showCreateLoan, setShowCreateLoan] = useState(false);
    const closeCreateLoan = () => setShowCreateLoan(false);
    const handleCreateLoan = () => setShowCreateLoan(true);
    const [rowDetailsforAddFielsToLoan, setRowDetailsforAddFielsToLoan] = useState();
    const [usecaseListForLoanCreation, setUsecaseListForLoanCreation] = useState(usecaseListForFileCreations);
    const [clientListForLoanCreation, setClientListForLoanCreation] = useState(clientListForFileCreations);
    const [admindetails, setAdmindetails] = useState(admindetailsFromMainForFileCreation);
    // const loanProps = {
    //     usecaseListForLoanCreation: usecaseListForFileCreations,
    //     clientListForLoanCreation:clientListForFileCreations,
    //     admindetailsFromMain:admindetailsFromMainForFileCreation,
    //     loanDetatils:rowDetailsforAddFielsToLoan
    // };
    //Reset Loan Usestates
    const [resetLoanshow, setResetLoanshow] = useState(false);
    const CloseResetLoan = () => setResetLoanshow(false);
    const showResetLoan = () => setResetLoanshow(true);
    const [rowDetailsforResetLoan, setRowDetailsforResetLoan] = useState();
    const [showhideAddFilestoLoan, setShowhideAddFilestoLoan] = useState(false)
    // Loan Import Data
    const [rowDetailsforLoanImportData, setRowDetailsforLoanImportData] = useState();
    // Default scroll height
    // const [scrollHeight, setScrollHeight] = useState('600px');
    const [expandedRowId, setExpandedRowId] = useState(null);
    const [isDisabledDeleteCondtion, setIsDisabledDeleteCondtion] = useState(true);

    // # --- BEGIN CHANGE ---
    // # Ticket  : DGV2-920
    // # Date    : 2026-07-29
    // # Author  : Shreya
    // # Summary : UI task - DGv2 Dashboard — Rows Per Page Selection Resets to 10 on Page Refresh
    const [rowsPerPage, setRowsPerPage] = useState(() => {
        const saved = localStorage.getItem('dashboardRowsPerPage');
        const parsed = Number(saved);
        return [10, 15, 20, 25, 30].includes(parsed) ? parsed : 10;
    });
    const handleRowsPerPageChange = (newPerPage) => {
        setRowsPerPage(newPerPage);
        localStorage.setItem('dashboardRowsPerPage', newPerPage);
    };
    // # --- END CHANGE ---

    const handleRowExpand = (isExpanded, row) => {
        // If the clicked row is already expanded, collapse it
        if (isExpanded) {
            setExpandedRowId(row.LG); // Expand the clicked row
            localStorage.setItem('isrowexpanded', true)
        } else {
            setExpandedRowId(null); // Collapse the row
            localStorage.setItem('isrowexpanded', false)
        }
    };
    const handlePopoverClick = (e, row) => {
        localStorage.setItem('isrowexpanded', false)
        // e.stopPropagation();
        // setExpansionTriggerSource('popover');
        // setPopoverTarget(row.LG);
        // setShowPopover(true);
    };
    const expandableRowsComponent = ({ data }) => (
        <ExpandedRowComponent orderDetails={data} />
    );
    //   Datagrid screen resolution begin
    // useEffect(() => {
    //     const handleResize = () => {
    //         const width = window.innerWidth;
    //         if (width === 1920) {
    //             setScrollHeight('615px');
    //         }
    //         else if (width === 1680) {
    //             setScrollHeight('580px');
    //         }
    //         else if (width === 1600) {
    //             setScrollHeight('450px');
    //         }
    //         else if (width === 1280) {
    //             setScrollHeight('600px');
    //         }
    //         else {
    //             setScrollHeight('600px');
    //         }
    //     };
    //     handleResize();
    //     window.addEventListener('resize', handleResize);
    //     return () => window.removeEventListener('resize', handleResize);
    // }, []);
    //   Datagrid screen resolution End
    // Prepare columns for the DataTable
    console.log(headers, data)
    const columnsToExclude = ['LK'];
    const columns = headers
        .filter(header => !columnsToExclude.includes(header.FN))
        .map(header => ({
            name: header.DN, // Display Name
            selector: row =>
                row[header.FN], // Field Name
            sortable: true, // Enable sorting
            width: header.Css, // Width from Css
            cell: row => (
                <OverlayTrigger
                    placement="top"
                    overlay={customTooltip(header.FN === "LA" ? formatCurrency(row[header.FN]) : row[header.FN])}

                >
                    <span className="text-truncate" onClick={() => navigateToGI(row)}>
                        {header.FN === "LA" ? (
                            formatCurrency(row[header.FN])
                        ) : header.FN === "LSts" ? (
                            <>
                                <i className={`ri-circle-fill me-1 ${getStatusClass(row[header.FN])}`}></i>
                                {row[header.FN]}
                            </>
                        ) : (
                            row[header.FN]
                        )}
                    </span>
                </OverlayTrigger>
            )
            // cell: row => {
            //     if (header.FN === "LA") {
            //         return (
            //             <OverlayTrigger
            //                 placement="top"
            //                 overlay={customTooltip(row[header.FN])}
            //             >
            //                 <span className="text-truncate">
            //                     {formatCurrency(row[header.FN])}
            //                 </span>
            //             </OverlayTrigger>
            //         );
            //     } else if (header.FN === "LSts") {
            //         return (
            //             <span className={getStatusClass(row[header.FN])}>
            //                 <i className="ri-circle-fill"></i> {row[header.FN]}
            //             </span>
            //         );
            //     } else {
            //         return (
            //             <OverlayTrigger
            //                 placement="top"
            //                 overlay={customTooltip(row[header.FN])}
            //             >
            //                 <span className="text-truncate">{row[header.FN]}</span>
            //             </OverlayTrigger>
            //         );
            //     }
            // }
        }));
    // const getStatusClass = (status) => {
    //     // console.log(status[0])
    //     if (status[0] === "Published") {
    //         return "text-primary";
    //     } else if (status[0] === "Pending IG Results") {
    //         return "text-secondary";
    //     } else if (status[0] === "Ready For Review") {
    //         return "text-success";
    //     } else if (status[0] === "Review for Approval") {
    //         return "text-danger";
    //     } else if (status[0] === "In Progress") {
    //         return "text-warning";
    //     } else if (status[0] === "Loan Created") {
    //         return "text-info";
    //     } else if (status[0] === "Review for Approval") {
    //         return "text-dark";

    //     } else {
    //         return "text-dark";
    //     }
    // };
    // Function to get class name based on loan status
    const getStatusClass = (status) => {
        switch (status.toUpperCase()) {
            case "PUBLISHED":
                return "text-primary";
            case "PENDING IG RESULTS":
                return "text-secondary";
            case "READY FOR REVIEW":
                return "text-success";
            case "REVIEW FOR APPROVAL":
                return "text-success";
            case "IN PROGRESS":
                return "text-warning";
            case "LOAN CREATED":
                return "text-info";
            case "IMAGE COPY FAILED":
                return "text-danger";
            case "IG ORDER IN PROGRESS":
                return "textpink";
            case "ERROR IN IG ORDER PROCESS":
                return "text-danger";

            default:
                return "text-warning";
        }
    };
    const formatCurrency = (value) => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    };
    const customTooltip = (text) => (
        <Tooltip id="tooltip">{text}</Tooltip>
    );
    // const columns = headers.map(header => ({
    //     // name: header,
    //     // selector: row => row[header],
    //     // sortable: true, // Enable sorting for each column
    //     name: header.DN, // Display Name
    //     selector: row => row[header.FN], // Field Name
    //     sortable: true, // Enable sorting
    //     width: header.Css, // Width from Css
    // }));
    console.log(columns, 'columns')
    // Add action column
    const [showPopover, setShowPopover] = useState(false);
    const [popoverTarget, setPopoverTarget] = useState(null);

    const handleToggle = (target) => {
        if (popoverTarget === target) {
            setShowPopover(!showPopover);
        } else {
            setShowPopover(true);
            setPopoverTarget(target);
        }
    };

    const handleClose = () => {
        setShowPopover(false);
        setPopoverTarget(null);
    };
    columns.push({
        name: '',
        cell: row => (
            <OverlayTrigger
                trigger="click"
                placement="left"
                rootClose={true}
                show={showPopover && popoverTarget === row.LG}
                onToggle={() => handleToggle(row.LG)}
                overlay={
                    <Popover id={`popover-${row.id}`} className="grid-popover" onClick={handleClose}>
                        <Popover.Body>
                            {/* <ListGroup variant="flush">
                                <ListGroup.Item onClick={(e) => { e.stopPropagation(); handleCreateLoan(); getRowDetailsForAddFielsToLoan(row); }}>Add Files to Loan</ListGroup.Item>
                                <ListGroup.Item onClick={(e) => { e.stopPropagation(); showResetLoan(); getRowDetailsForResetLoan(row); }}>Reset Loan</ListGroup.Item>
                                <ListGroup.Item > Download Evaluated Excel Rules</ListGroup.Item>
                                <ListGroup.Item onClick={(e) => { e.stopPropagation(); getRowDetailsForLoanImportData(row); }}> Loan Import Data</ListGroup.Item>
                                <ListGroup.Item > Delete Conditions</ListGroup.Item>
                            </ListGroup> */}
                            <ul className="popoverClass">
                                {hasRightsToAddFilesToLoans() && (<li className="popoverItemClass" onClick={(e) => { handleCreateLoan(); getRowDetailsForAddFielsToLoan(row); }}><BiChevronRightCircle style={{ fontSize: '14px' }} /> Add Files to Loan</li>)}
                                {/* <li className="popoverItemClass" onClick={(e) => { showResetLoan(); getRowDetailsForResetLoan(row); }}><BiChevronRightCircle style={{ fontSize: '14px' }} /> Reset Loan</li> */}
                                {/* {localStorage.getItem("Role")?.toLowerCase() === "dg-superadmin" && (
                                    <li
                                        className={`popoverItemClass ${(row.LSts !== "Published" && row.LSts !== "Ready For Review" && row.LSts !== "Completed") ? 'disabled' : ''}`}
                                        onClick={(e) => {
                                            if (row.LSts === "Published" || row.LSts === "Ready For Review"|| row.LSts === "Completed") {
                                                downloadEvaluatedSheet(row);
                                            }
                                        }}
                                        style={{
                                            cursor: (row.LSts !== "Published" && row.LSts !== "Ready For Review"&& row.LSts !== "Completed") ? 'not-allowed' : 'pointer',
                                            opacity: (row.LSts !== "Published" && row.LSts !== "Ready For Review"&& row.LSts !== "Completed") ? 0.5 : 1
                                        }}
                                    >
                                        <BiChevronRightCircle style={{ fontSize: '14px' }} /> Download Evaluated Sheet
                                    </li>
                                )} */}
                                {hasRightsToDownloadedEvaluatedRuleSheet() && (
                                    <li className="popoverItemClass" onClick={(e) => downloadEvaluatedSheet(row)}>
                                        <BiChevronRightCircle style={{ fontSize: '14px' }} /> Download Evaluated Sheet
                                    </li>
                                )}
                                {hasRightsToLoanImportData() && (<li className="popoverItemClass" onClick={(e) => { getRowDetailsForLoanImportData(row); }}><BiChevronRightCircle style={{ fontSize: '14px' }} /> Loan Import Data</li>)}
                                <li
                                    className={`popoverItemClass ${isDisabledDeleteCondtion ? 'disabled' : ''}`} // Add a class if disabled
                                    onClick={(e) => {
                                        if (!isDisabledDeleteCondtion) {
                                            deleteCondition(row);
                                        }
                                    }}
                                    style={{ cursor: isDisabledDeleteCondtion ? 'not-allowed' : 'pointer', opacity: isDisabledDeleteCondtion ? 0.5 : 1 }} // Change cursor style
                                >
                                    <BiChevronRightCircle style={{ fontSize: '14px' }} /> Delete Conditions
                                </li>
                                {/* <li
                                    className={`popoverItemClass ${row.AprSts === ""&&row.LSts!=="Completed" ? 'disabled' : ''}`}
                                    onClick={(e) => {
                                        if (row.AprSts !== ""&&row.LSts!=="Completed") {
                                            reRunEules(row);
                                        }
                                    }}
                                    style={{
                                        cursor: row.AprSts === ""||row.LSts==="Completed" ? 'not-allowed' : 'pointer',
                                        opacity: row.AprSts === ""||row.LSts==="Completed" ? 0.5 : 1
                                    }}
                                >
                                    <BiChevronRightCircle style={{ fontSize: '14px' }} /> Re-run Rules
                                </li> */}
                                {hasRightsToReRunRules() && (
                                    <li className={`popoverItemClass ${row.LSts !== "Completed" ? 'disabled' : ''}`}
                                        onClick={(e) => {
                                            if (row.LSts !== "Completed") {
                                                reRunEules(row);
                                            }
                                        }}
                                        style={{
                                            cursor: row.LSts === "Completed" ? 'not-allowed' : 'pointer',
                                            opacity: row.LSts === "Completed" ? 0.5 : 1
                                        }}>
                                        <BiChevronRightCircle style={{ fontSize: '14px' }} /> Re-run Rules
                                    </li>
                                )}
                            </ul>
                        </Popover.Body>
                    </Popover>
                }
                onClick={(e) => e.stopPropagation()} // Stop propagation here
            >
                <span onClick={(e) => handlePopoverClick(e, row)}>
                    <i className="ri-more-2-fill" />
                </span>
            </OverlayTrigger>
        ),
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
    });
    const getRowDetailsForResetLoan = (clickedrowdetails) => {
        setRowDetailsforResetLoan(clickedrowdetails);
    }
    const getRowDetailsForAddFielsToLoan = (clickedrowdetails) => {
        localStorage.setItem('showaddfilesloanpopup', true);
        localStorage.setItem('showloancreatepopup', false)
        setShowhideAddFilestoLoan(Boolean(localStorage.getItem('showaddfilesloanpopup')));
        setRowDetailsforAddFielsToLoan(clickedrowdetails)
    }
    // For Loan Import Data
    const openInLoanImportNewWindow = (data) => {
        const newWindow = window.open('', '_blank', 'width=1024,height=768');
        newWindow.document.title = 'Loan Import Data';

        // Add Bootstrap CSS
        const link = newWindow.document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/css/bootstrap.min.css';
        newWindow.document.head.appendChild(link);

        // Add Bootstrap JS
        const script = newWindow.document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/bootstrap@5.3.3/dist/js/bootstrap.bundle.min.js';
        newWindow.document.body.appendChild(script);

        // Add external CSS file
        const externalCssLink = newWindow.document.createElement('link');
        externalCssLink.rel = 'stylesheet';
        externalCssLink.href = '/loan-import.css';  // Replace with your external CSS file URL
        newWindow.document.head.appendChild(externalCssLink);

        if (newWindow) {
            newWindow.document.body.innerHTML = '<div id="root"></div>';

            // Create a root and render the component
            const root = ReactDOM.createRoot(newWindow.document.getElementById('root'));
            root.render(
                <LoanImportData rowDetailsforLoanImportDatas={data} />
            );
        }
    };
    const getRowDetailsForLoanImportData = (clickedrowdetailsforloanimportdata) => {
        setRowDetailsforLoanImportData(clickedrowdetailsforloanimportdata);
        openInLoanImportNewWindow(clickedrowdetailsforloanimportdata);
        console.log(clickedrowdetailsforloanimportdata, 'clickedrowdetailsforloanimportdata')
    }
    const navigateToGI = (row) => {
        if (hasRightsToReviewLoans()) {
            localStorage.setItem('loanGuid', row.LG)
            localStorage.setItem('loanStatusofLoan', row.LSts)
            if (
                ((row.LSts === "Ready For Review" && hasRightsToReadyForReview()) && ((row.AprSts === "Review for Approval" && hasRightsToReviewForApproval()) || (row.AprSts === "Review for Decline" && hasRightsToReviewForDecline())))
                || ((row.LSts === "Published" && hasRightsToCompletedLoans()) && ((row.AprSts === "Review for Approval" && hasRightsToReviewForApproval()) || (row.AprSts === "Review for Decline" && hasRightsToReviewForDecline())))
                || ((row.LSts === "Completed") && hasRightsToCompletedLoans())
            ) {
                localStorage.setItem('activeTab', 'pills-decisiondashboard');
                navigate('/general-information');

            } else {
                toast.error("Not authorized to access loan", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        } else {
            toast.warning("Not authorized to access loan", {
                position: "bottom-center",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
    }
    const deleteCondition = async (row) => {
        try {
            const parsedBody = await invokeLambda(configData.DELETE_CONDITIONS, {
                ...lambdaConfig,
                SecurityToken: localStorage.getItem('SecurityToken'),
                "LoanGuid": localStorage.getItem('loanGuid'),
            });
            if (parsedBody.Status) {
                toast.success("Condition Deleted Sucessfully", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            } else {
                toast.error("Condition Not Deleted Sucessfully", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        } catch (err) {
            // Handle error if needed
        }
    }
    const downloadEvaluatedSheet = async (row) => {
        setDotLoader(false);
        const data = {
            Command: configData.RULE_RESULT_DOWNLOAD,
            ClientShortName: localStorage.getItem('ClientShortName').trim(),
            UseCaseShortName: localStorage.getItem('UseCaseShortName').trim(),
            SecurityToken: localStorage.getItem("SecurityToken"),
            LoanGuid: row.LG,
            SecurityId: null,
            EventContextId: null,
            CallerSourceId: null,
            CallerSourceName: null,
        };
        const params = {
            FunctionName: configData.LAMBDA_FUNCTION_NAME1,
            Payload: JSON.stringify(data)
        };

        lambda.invoke(params, (err, data) => {
            if (err) {
                console.log(err, err.stack);
            } else {
                let lambdaResponse = JSON.parse(data.Payload.toString());
                const parsedBody = JSON.parse(lambdaResponse.body);
                if (parsedBody.Status === true) {
                    AWS.config.credentials = new AWS.Credentials({
                        accessKeyId: decrypt(getCookie('ak')),
                        secretAccessKey: decrypt(getCookie('sk'))
                    });

                    const s3 = new AWS.S3({
                        region: 'us-east-1',
                    });

                    parsedBody.Output.forEach(file => {
                        const params = {
                            Bucket: file.drpbuck,
                            Key: file.flnmewthpth,
                            Expires: 300 // The URL will now expire in 5 minutes (300 seconds)
                        };

                        try {
                            const url = s3.getSignedUrl('getObject', params);
                            window.open(url, '_blank');
                        } catch (error) {
                            console.error('Error generating signed URL:', error);
                            toast.error("Error generating signed URL", {
                                position: "bottom-center",
                                autoClose: 2000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "colored",
                            });

                        }
                    });

                    toast.success("Report(s) Downloaded Successfully", {
                        position: "bottom-center",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                    setTimeout(() => {
                        setDotLoader(true);
                    }, 1000);
                } else {
                    toast.error("Error in downloading report", {
                        position: "bottom-center",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "colored",
                    });
                    setTimeout(() => {
                        setDotLoader(true);
                    }, 1000);
                    // Handle the case where the status is not true
                    console.error('Invalid response status:', parsedBody.Status);
                    // alert('Failed to retrieve file information. Please check the response.');
                }

            }
        });
    }
    const reRunEules = async (row) => {
        setDotLoader(false);
        try {
            const parsedBody = await invokeLambda(configData.RUN_RULES, {
                ...lambdaConfig,
                SecurityToken: localStorage.getItem('SecurityToken'),
                "LoanGuid": row.LG,
                "ClientShortName": localStorage.getItem('ClientShortName'),
                "UseCaseShortName": localStorage.getItem('UseCaseShortName')
            });
            if (parsedBody.Status) {
                toast.success("Re-run Rules initiated sucessfully", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setTimeout(() => {
                    setDotLoader(true);
                }, 1000);
            } else {
                toast.error("Re-run Rules initiated failed", {
                    position: "bottom-center",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
                setTimeout(() => {
                    setDotLoader(true);
                }, 1000);
            }
        } catch (err) {
            // Handle error if needed
        }
    }
    const screenWidth = window.innerWidth;
    const screenHeight = window.innerHeight;
    let minHeight;

    if (screenWidth == 1920) {
        minHeight = '623px';
    } else if (screenWidth == 1680) {
        minHeight = '597px';
    } else if (screenWidth == 1600) {
        minHeight = '467px';
    }
    // else if (screenWidth == 1280) {
    //     minHeight = '621px';
    // } 
    else {
        minHeight = 'calc(100vh - 264px)';
    }
    const customStyles = {

        table: {
            style: {
                //minHeight: 'calc(100vh - 280px)', 
                minHeight,
                backgroundColor: 'white',
                overflowY: 'auto',
            },
        },


    };
    const hasRightsToDashboardOrdersAccess = () => {

        if (rolesAndRights !== null) {

            let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "DASHBOARD_ORDERS_ACCESS")?.RightId;

            if (userRights.some(el => el.RightId == rightID)) {

                return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;

            }

        }

    }
    const hasRightsToDownloadedEvaluatedRuleSheet = () => {

        if (rolesAndRights !== null) {

            let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "DOWNLOAD_EVALUATED_RULE_SHEET")?.RightId;

            if (userRights.some(el => el.RightId == rightID)) {

                return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;

            }

        }

    }
    const hasRightsToReRunRules = () => {

        if (rolesAndRights !== null) {

            let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "RE_RUN_RULES")?.RightId;

            if (userRights.some(el => el.RightId == rightID)) {

                return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;

            }

        }

    }
    const hasRightsToResetOrder = () => {

        if (rolesAndRights !== null) {

            let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "RESET_ORDER")?.RightId;

            if (userRights.some(el => el.RightId == rightID)) {

                return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;

            }

        }

    }
    const hasRightsToAddFilesToLoans = () => {

        if (rolesAndRights !== null) {

            let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "ADD_FILES_TO_LOAN")?.RightId;

            if (userRights.some(el => el.RightId == rightID)) {

                return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;

            }

        }

    }
    const hasRightsToLoanImportData = () => {

        if (rolesAndRights !== null) {

            let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "LOAN_IMPORT_DATA")?.RightId;

            if (userRights.some(el => el.RightId == rightID)) {

                return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;

            }

        }

    }
    const hasRightsToReviewLoans = () => {

        if (rolesAndRights !== null) {

            let rightID = rolesAndRights.AllRights.find(el => el.RightType.trim() == "REVIEW_LOAN")?.RightId;

            if (userRights.some(el => el.RightId == rightID)) {

                return userRights.find(el => el.RightId == rightID).RightValue == 1 ? true : false;

            }

        }

    }
    const hasRightsToReviewForApproval = () => {
        if (rolesAndRights !== null) {
            let rightID = rolesAndRights?.AllRights?.find(el => el.RightType.trim() == "REVIEW_FOR_APPROVAL")?.RightId;
            if (JSON.parse(localStorage.getItem("UserRights")).some(el => el.RightId == rightID)) {
                return JSON.parse(localStorage.getItem("UserRights"))?.find(el => el.RightId == rightID).RightValue == 1 ? true : false;
            }
        }
    }

    const hasRightsToReviewForDecline = () => {
        if (rolesAndRights !== null) {
            let rightID = rolesAndRights?.AllRights?.find(el => el.RightType.trim() == "REVIEW_FOR_DECLINE")?.RightId;
            if (JSON.parse(localStorage.getItem("UserRights")).some(el => el.RightId == rightID)) {
                return JSON.parse(localStorage.getItem("UserRights"))?.find(el => el.RightId == rightID).RightValue == 1 ? true : false;
            }
        }
    }

    const hasRightsToReadyForReview = () => {
        if (rolesAndRights !== null) {
            let rightID = rolesAndRights?.AllRights?.find(el => el.RightType.trim() == "READY_FOR_REVIEW")?.RightId;
            if (JSON.parse(localStorage.getItem("UserRights")).some(el => el.RightId == rightID)) {
                return JSON.parse(localStorage.getItem("UserRights"))?.find(el => el.RightId == rightID).RightValue == 1 ? true : false;
            }
        }
    }

    const hasRightsToCompletedLoans = () => {
        if (rolesAndRights !== null) {
            let rightID = rolesAndRights?.AllRights?.find(el => el.RightType.trim() == "COMPLETED_LOANS")?.RightId;
            if (JSON.parse(localStorage.getItem("UserRights")).some(el => el.RightId == rightID)) {
                return JSON.parse(localStorage.getItem("UserRights"))?.find(el => el.RightId == rightID).RightValue == 1 ? true : false;
            }
        }
    }

    return (
        <>
            {dotloader ? (<div className={hasRightsToDashboardOrdersAccess() ? 'grid-one' : 'grid-two'}><DataTable
                columns={columns}
                data={data}
                pagination // Enable pagination
                paginationResetDefaultPage={resetPaginationToggle}
                // # --- BEGIN CHANGE ---
                // # Ticket  : DGV2-920
                // # Date    : 2026-07-29
                // # Author  : Shreya
                // # Summary : UI task - DGv2 Dashboard — Rows Per Page Selection Resets to 10 on Page Refresh
                paginationPerPage={rowsPerPage}
                onChangeRowsPerPage={handleRowsPerPageChange}
                // # --- END CHANGE ---
                striped // Add striped rows
                expandableRows={hasRightsToDashboardOrdersAccess()}
                expandableRowsComponent={expandableRowsComponent}
                onRowExpandToggled={handleRowExpand}
                expandableRowExpanded={row => row.LG === expandedRowId} // Check if the row should be expanded
                fixedHeader
                //  fixedHeaderScrollHeight={scrollHeight}
                pointerOnHover
                dense
                onRowClicked={(row) => navigateToGI(row)}
                customStyles={customStyles}

            /></div>) : (
                <div style={{ marginTop: "20%", marginBottom: "20%" }} className="d-flex justify-content-center">
                    <div className="loader"></div>
                </div>
            )}

            {showhideAddFilestoLoan && <CreateLoan show={showCreateLoan} handleClose={closeCreateLoan} usecaseListForLoanCreations={usecaseListForLoanCreation}
                clientListForLoanCreations={clientListForLoanCreation}
                admindetailsFromMain={admindetails}
                createLoanUsecaseid={createLoanUsecaseid}
                createLoanClientid={createLoanClientid}
                loanDetatils={rowDetailsforAddFielsToLoan}
                isNewLoan={false} />}
            <ResetDashboardLoan show={resetLoanshow && hasRightsToResetOrder} handleClose={CloseResetLoan} rowDetailsforResetLoans={rowDetailsforResetLoan} />

        </>
    );
};
export default DashboardGridData;